import Cookies from 'universal-cookie'
import axios from 'axios'
import 'whatwg-fetch'
import constants from '../constants'
import jwtDecode from 'jwt-decode'
import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'

const client = axios.create({
  headers: { 'Content-Type': 'application/json' }
})
const cookieArgs = {path: '/', domain: constants.cookieDomain}

export default class Api {
  cookies = new Cookies()

  performPasswordReset(args, failureCallback = (err) => {}) {
    const { token, password, passwordConfirmation } = args

    if(!password) {
      failureCallback({password: "Please enter your password"})
      return
    }

    if(!passwordConfirmation) {
      failureCallback({passwordConfirmation: "Please confirm your password"})
      return
    }

    const body = JSON.stringify({
      password_reset: {
        password: password,
        password_confirmation: passwordConfirmation
      }
    })

    fetch(`${constants.passwordResetEndpoint}/${token}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {
      if (response && response.meta && response.meta.status === "ok") {
        window.location = constants.loginUrl
      }
      else {
        let errors = {}
        Object.keys(response.errors).forEach(key => {
          errors[key] = response.errors[key].join(", ")
        })

        failureCallback && failureCallback(this._camelcaseKeys(errors))
      }
    })
    // .catch((error) => {
    //   failureCallback({base: error.message})
    // })
  }

  loginWithGoogle(googleToken, googleId, email, failureCallback = (err) => {}) {
    if(!googleToken) {
      failureCallback({base: "Missing googleToken"})
      return
    }
    else if(!googleId) {
      failureCallback({base: "Missing googleId"})
      return
    }
    else if(!email) {
      failureCallback({base: "Missing email"})
      return
    }

    const body = JSON.stringify({
      auth: {
        googleId,
        googleToken,
        email
      }
    })

    fetch(constants.loginEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response
      }
      else {
        failureCallback({base: "This google account is not associated with a CatholicSingles.com membership.  Try another Google account or sign up for a new CatholicSingles.com membership"})
      }
    })
    .then((response) => response.json())
    .then((response) => {
      this.performLoginAndRedirect(response.token)
    })
    .catch((error) => {
      failureCallback({base: "This google account is not associated with a CatholicSingles.com membership.  Try another Google account or sign up for a new CatholicSingles.com membership"})
    })
  }

  loginWithFacebook(facebookToken, facebookId, email, failureCallback = (err) => {}) {
    if(!facebookToken) {
      failureCallback({base: "Missing facebookToken"})
      return
    }
    else if(!facebookId) {
      failureCallback({base: "Missing facebookId"})
      return
    }

    const body = JSON.stringify({
      auth: {
        facebookId,
        facebookToken,
        email
      }
    })

    fetch(constants.loginEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response
      }
      else {
        failureCallback({base: "Facebook user not found.  Try another account or sign up with a new account"})
      }
    })
    .then((response) => response.json())
    .then((response) => {
      console.log(response)
      this.performLoginAndRedirect(response.token)
    })
    .catch((error) => {
      failureCallback({base: "Facebook user not found.  Try another account or sign up with a new account"})
    })
  }

  requestPasswordReset(email, successCallback = null, failureCallback = null) {
    if(!email) {
      failureCallback({email: "Please enter your email"})
      return
    }

    const body = JSON.stringify({
      password_reset: {
        email: email
      }
    })

    fetch(constants.passwordResetEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response
      }
      else {
        failureCallback && failureCallback({base: "Invalid email entered"})
      }
    })
    .then((response) => response.json())
    .then((response) => {
      successCallback && successCallback()
    })
    .catch((error) => {
      failureCallback && failureCallback({base: "Invalid email entered"})
    })
  }

  loginWithEmail(email, password, failureCallback = (err) => {}) {
    if(!email && !password) {
      failureCallback({email: "Please enter your email", password: "Please enter your password"})
      return
    }
    else if(!email) {
      failureCallback({email: "Please enter your email"})
      return
    }
    else if(!password) {
      failureCallback({password: "Please enter your password"})
      return
    }

    const body = JSON.stringify({
      auth: {
        email: email,
        password: password
      }
    })

    client.post(constants.loginEndpoint, body)
    .then((response) => {
      console.log(response)
      this.performLoginAndRedirect(response.data.token)
    })
    .catch(error => {
      if(error.response) {
        failureCallback({base: "Invalid email or password entered"})
      }
      else if(error && error.message === "Network Error") {
        failureCallback({base: "Unable to establish connection to server.  Refresh the page and try again."})
      }
      else {
        failureCallback({base: "Invalid email or password entered"})
      }
    })
  }


  validateParameters(args = {}, successCallback = null, failureCallback = null) {
    const body = JSON.stringify({membership: this._snakecaseKeys(args)})

    fetch(constants.validateEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {
      if(response && response.meta && response.meta.status === "ok") {
        successCallback && successCallback()
      }
      else {
        let errors = {}
        Object.keys(response).forEach(key => {
          errors[key] = response[key].join(", ")
        })

        failureCallback && failureCallback(this._camelcaseKeys(errors))
      }
    })
    .catch((error) => {
      failureCallback && failureCallback({base: `An error occurred trying to contact the server: ${error.message}.  Please refresh your browser and try again.`})
    })
  }

  createAccount(args = {}, failureCallback = null) {
    const { firstName, lastName, email, displayName, password, passwordConfirmation, birthmonth, birthday, birthyear, gender, city, stateId, postalCode, countryId, facebookToken, facebookId, googleId, googleToken, termsAgreed, affiliateId, utmSource, utmMedium, utmTerm, utmContent, utmCampaign, ageInterestedLow, ageInterestedHigh, talon } = args

    let params = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      display_name: displayName,
      birthmonth: birthmonth,
      birthday: birthday,
      birthyear: birthyear,
      gender: gender,
      city: city,
      state_id: stateId,
      postal_code: postalCode,
      country_id: countryId,
      terms_agreed: termsAgreed,
      affiliate_id: affiliateId,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_term: utmTerm,
      utm_content: utmContent,
      utm_campaign: utmCampaign,
      age_interested_low: ageInterestedLow,
      age_interested_high: ageInterestedHigh,
      talon: talon
    }

    if(googleId && googleToken) {
      params["google_id"] = googleId
      params["google_token"] = googleToken
    }
    else if(facebookId && facebookToken) {
      params["facebook_id"] = facebookId
      params["facebook_token"] = facebookToken
    }
    else {
      params["password"] = password
      params["passwordConfirmation"] = passwordConfirmation
    }

    const body = JSON.stringify({membership: params})

    fetch(constants.signupEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {
      if(response && response.meta && response.meta.status === "ok") {
        this.trackConversion()
        this.completeSignupAndStartOnboarding({ token: response.token, member: response.member })
      }
      else {
        let errors = {}
        Object.keys(response).forEach(key => {
          errors[key] = response[key].join(", ")
        })

        failureCallback && failureCallback(this._camelcaseKeys(errors))
      }
    })
    .catch((error) => {
      failureCallback && failureCallback({base: `An error occurred trying to contact the server: ${error.message}.  Please refresh your browser and try again.`})
    })
  }

  trackConversion() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'newMemberRegistration'});
  }

  completeSignupAndStartOnboarding({ token, member}) {
    this.cookies.set('authToken', token, cookieArgs)
    this.cookies.set('cs-has-photos' , member.has_essays, cookieArgs)
    this.cookies.set('cs-has-essays', member.has_essays, cookieArgs)
    this.cookies.set('cs-has-personality-tests', member.has_personality_tests, cookieArgs)
    this.cookies.set('cs-limited', member.limited, cookieArgs)
    this.cookies.set('cs-gender', member.gender, cookieArgs)

    this.performLoginAndRedirect(token)
  }

  performJwtLogin(token) {
    const decoded = jwtDecode(token)

    const redirectUrl = this.cookies.get('redirect-after-login')

    this.cookies.set('token', token, cookieArgs)
    this.cookies.set('cs-has-photos' , decoded.has_essays, cookieArgs)
    this.cookies.set('cs-has-essays', decoded.has_essays, cookieArgs)
    this.cookies.set('cs-has-personality-tests', decoded.has_personality_tests, cookieArgs)
    this.cookies.set('cs-limited', decoded.limited, cookieArgs)
    this.cookies.set('cs-gender', decoded.gender, cookieArgs)

    if(redirectUrl && typeof(redirectUrl) === 'string') {
      this.cookies.remove('redirect-after-login', cookieArgs)
      window.location = redirectUrl
    }
    else {
      window.location = constants.dashboardUrl
    }
  }

  performLoginAndRedirect(token) {
    let redirectUrl = `${constants.authenticateUrl}/${token}`

    const redirectAfter = this.cookies.get('redirect-after-login')
    if(redirectAfter) {
      redirectUrl = `${redirectUrl}?redirect=${encodeURIComponent(redirectAfter)}`
      this.cookies.remove('redirect-after-login', cookieArgs)
    }

    this.cookies.set('authToken', token, cookieArgs)

    window.location = redirectUrl
  }

  _camelcaseKeys(obj) {
    return Object.keys(obj).reduce((ccObj, field) => ({
      ...ccObj,
      [camelCase(field)]: obj[field]
    }), {})
  }

  _snakecaseKeys(obj) {
    return Object.keys(obj).reduce((ccObj, field) => ({
      ...ccObj,
      [snakeCase(field)]: obj[field]
    }), {})
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js